<div [ngClass]="class" (click)="openUpload($event)">
    <mat-label>{{ label | transloco }}</mat-label>
    <label class="upload-button dark:bg-gray-800 dark:text-white">
        <!-- (click)="fileUpload.click()" -->
        <mat-icon
            class="text-gray-400 icon-size-5 dark:bg-gray-800 dark:text-white"
            matPrefix
            [svgIcon]="'mat_outline:broken_image'"
        >
        </mat-icon>
        <input
            type="file"
            [accept]="accept"
            (change)="uploadImage($event)"
            [required]="isRequired"
            #fileUpload
        />
        <span *ngIf="!value && form?.get(controlName).invalid" class="ml-2 mr-2"
            >{{ "Select" | transloco }} {{ label | transloco }}
        </span>
        <span *ngIf="!value && !form" class="ml-2 mr-2"
            >{{ "Select" | transloco }} {{ label | transloco }}
        </span>
        <img
            *ngIf="!value && form?.get(controlName).valid && type === 'image'"
            [src]="override.imageUrl + form.get(controlName).value"
            style="height: 50px; width: auto"
            alt=""
            crossorigin="anonymous"
        />
        <img
            *ngIf="value && type === 'image'"
            [src]="override.imageUrl + value"
            style="height: 50px; width: auto"
            alt=""
            crossorigin="anonymous"
        />
        <span
            *ngIf="!value && form?.get(controlName).valid && type === 'video'"
            class="ml-2 mr-2"
            >{{ "Video Uploaded Click To Replace" | transloco }}
        </span>
        <ng-content select="[deleteBtn]"></ng-content>
    </label>
</div>
<video
    *ngIf="!value && form?.get(controlName).valid && type === 'video'"
    controls
    height="120px"
>
    <!-- <source src="http://localhost:5000/v1/File/61ddf95c969a6f275ca2d099" type="video/mp4"> -->
    <source
        [src]="override.imageUrl + form.get(controlName).value"
        type="video/mp4"
    />
</video>
